import React from "react";
import InputTypesEnum from "../../../../Enums/InputTypesEnum";
import BaseCard from "./BaseCard";

class PricingDetailStatus extends BaseCard {
  state = {};
  render() {
    const { Tier } = this.props;
    const pd = Tier.PricingDetails;
    const isFinal = pd.Status === 'Final';
    const isLoss = Number(Tier.MarkedUpRevenueTotal) - Number(Tier.TotalCosts) < 0;
    return (
      <div className='card pd-hero'>
        <div className='pd-hero-top'>
          <div className='pd-hero-id'>
            <div className='pd-hero-eyebrow'>Pricing Detail{pd.PricingDetailId ? ' · #' + pd.PricingDetailId : ''}</div>
            <div className='pd-hero-name'>
              <div className='Figma-input-group'>{this.renderInputField('Name', '', '', InputTypesEnum.Text2, null, '', false)}</div>
            </div>
            <div className='pd-hero-meta'>
              {pd.CurrencyCode && (
                <span><span className='k'>Currency</span><span className='num'>{pd.CurrencyCode}</span></span>
              )}
              {pd.FieldworkCycle && (
                <span><span className='k'>Cycle</span><span className='num'>{pd.FieldworkCycle}</span></span>
              )}
            </div>
          </div>
          <span className={'pd-status' + (isFinal ? ' final' : '')}><span className='dot' />Status: {pd.Status}</span>
        </div>
        <div className='pd-kpis'>
          <div className='pd-kpi'>
            <span className='kl'>Total Revenue</span>
            <span className='kv'>{Tier.RevenueTotal}</span>
          </div>
          <div className={'pd-kpi' + (isLoss ? ' neg' : '')}>
            <span className='kl'>Total Costs</span>
            <span className='kv'>{Tier.CostTotal}</span>
            <span className='ks'>{Tier.CostPct} of revenue</span>
          </div>
          <div className={'pd-kpi' + (isLoss ? ' neg' : ' pos')}>
            <span className='kl'>Net Revenue</span>
            <span className='kv'>{Tier.NetRevenueTotal}</span>
            <span className='ks'>{Tier.RevenuePct} margin</span>
          </div>
        </div>
        {isLoss && (
          <div className='pd-alert'>
            <i className='fa-solid fa-triangle-exclamation' />
            <span className='at'>This pricing detail is running at a <b>loss</b> — costs exceed revenue. Review the cost sections before finalizing.</span>
          </div>
        )}
      </div>
    );
  }
}

export default PricingDetailStatus;
